var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.owlCarousel(options);
	}
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	//$('.children', '#mMenu ').prepend('<a class="expand" href="#"><span>+</span></a>');

	site.nav.bind();
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mMenu').bind('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		var $ul = $this.siblings('ul');

		$ul.toggleClass('hide');
		$this.next().toggleClass('down');
		$this.toggleClass('down');
		e.preventDefault();
	});
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$(window).scrollTop(scrollPosition);
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});

	$menu.append($html);
};

site.frontpage = {
	init: function() {
		if (!$('body').hasClass('frontpage')) return;

		$('#center .box_newsevents .entry').hover(function(){
			$('.entryInfo',this).toggleClass('hover');
		});
	}
};


// Run all the inits \o/
$(function() {
	site.nav.init();
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});
	site.frontpage.init();


	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);

	$('#qn #searchMini').click(function() {
		$('#searchBox').toggleClass('hide');
		$(this).toggleClass('hover');
	});
	$('#mainmenu .mmLevel1 li:not(:has(> ul))').removeClass('children');

	if(!($.browser.msie && parseInt($.browser.version,10) === 7)) {
		$('#mainmenu .level2:last').addClass('last');
		$('#mainmenu .mmLevel2:last').addClass('end');
		$('#mainmenu .mmLevel1 .children').hover(function(){
				$('.mmLevel2',this).addClass('hover').show();
				$('a:first',this).addClass('hover');
			},
			function(){
				$('.mmLevel2',this).removeClass('hover').hide();
				$('a:first',this).removeClass('hover');
			});
	}
	$('#center .boxText .table1 tr:first').addClass('first');
	$('#center .boxText .table1 tr:odd').addClass('odd');
	$('#center .boxText .table2 tr:odd').addClass('even');
	var mw = $('#mainmenu').width()-46;
	$('#qn').css('width',mw+'px');
});
